var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconJoyCashWebLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        ", "\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.1,21.9h0s0,0,0,0c0,0,0,0,0,0,1.6-1.3,2.6-3,2.8-5.1.2-2-.3-4-1.6-5.6-1.4-1.8-3.6-2.8-5.9-2.8s-3.3.6-4.7,1.6c0,0,0,0,0,0,0,0,0,0,0-.1,0-4.3-3.6-7.7-7.9-7.5-3.8.2-7,3.3-7.2,7.1,0,.2,0,.3,0,.5,0,0,0,0,0,0-1.4-1.1-3-1.6-4.7-1.6s-4.5,1-5.9,2.8c-1.3,1.6-1.8,3.5-1.6,5.6.2,2,1.2,3.8,2.8,5.1h0c0,0,0,0,0,0-4.1.9-6.6,5-5.7,9,.8,3.5,3.8,5.9,7.4,5.9s1.1,0,1.7-.2c0,0,0,0,0,0,0,0,0,0,0,0-.9,1.8-1,3.9-.3,5.8.7,1.9,2,3.4,3.9,4.3,1,.5,2.1.7,3.3.7,2.9,0,5.6-1.7,6.8-4.3,0,0,0,0,0,0,0,0,0,0,0,0,1.2,2.6,3.9,4.3,6.8,4.3s2.2-.3,3.3-.7c1.8-.9,3.2-2.4,3.9-4.3.7-1.9.6-4-.3-5.8,0,0,0,0,0,0,0,0,0,0,0,0,.6.1,1.1.2,1.7.2,3.5,0,6.6-2.4,7.4-5.9.9-4.1-1.6-8.1-5.7-9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.6,
    y1: 12.1,
    x2: 25.6,
    y2: 39.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.4,25.9c-3.6-.4-6.3-2.9-6-5.6s3.5-4.6,7.1-4.2c1.6.2,3.1.8,4.2,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.7,26c3.6.4,6.3,2.9,6,5.6s-3.5,4.6-7.1,4.2-3.1-.8-4.2-1.7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconJoyCashWebLine);
export default __webpack_public_path__ + "static/media/cloud_icon_joy_cash_web_line.3816032e1f9b21a97abd91d9f70f7bac.svg";
export { ForwardRef as ReactComponent };